import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    pagination: {
      page: 1,
      size: 25
    },
    echartsData:{},
    datas: [],
    totalCount: 0,
    detail: null,
    coinTypes: [],
    symbolData:[],
    transcationData:[],
    userProfitData:[],
    symbolProfitData:[],
    columnData:[],
    staticalList:[],
    totalStaticalList:{},
  },
  getters: {
    list: state => {
      return state.datas.map(item => ({
        ...item
      }));
    }
  },
  mutations: {
    setCoinTypes(state, payload) {
      state.coinTypes = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDetail(state, payload) {
      state.detail = payload;
    },
    setEchartsData(state, payload) {
      state.echartsData = payload;
      // console.log('state.data',state.echartsData);
    },
    setSymbolData(state, payload) {
      state.symbolData = payload.map(item=>{
        return item.symbol
      })
     
    },
    setTranscationData(state, payload) {
      state.transcationData = payload || []
     
    },
    setUserProfit(state, payload) {
      state.userProfitData = payload || []
     
    },
    setSymbolProfit(state, payload) {
      state.symbolProfitData = payload || []
     
    },
    setColumnData(state, payload) {
      state.columnData = payload || []
     
    },
    setStaticalList(state, payload) {
      state.staticalList = payload.list || []
    },
    setTotalStaticalList(state, payload) {
      state.totalStaticalList = payload || {}
    },
    setTotalCount(state, payload) {
      state.totalCount = payload 
    },
  },
  actions: {
    getTurnover({commit},data){
    return  api.getTurnover(data).then(res=>{
        commit('setEchartsData',res.data)
        return res
      })
    },
    getTranscation({commit},data){
    return  api.getTranscation(data).then(res=>{
        // commit('setEchartsData',res.data)
        commit('setTranscationData',res.data)
        return res
      })
    },
    getUserProfit({commit},data){
     return api.getUserProfit(data).then(res=>{
        commit('setUserProfit',res.data)
        return res
      })
    },
    getSymbolProfit({commit},data){
      return api.getSymbolProfit(data).then(res=>{
        commit('setSymbolProfit',res.data)
        return res
      })
    },
    getColumnData({commit},data){
      return api.getColumnData(data).then(res=>{
       
        commit('setColumnData',res.data)
        return res
      })
    },
    getStaticalChart({commit},data){
      console.log('pagination--------',data);
      return api.getStaticalChart(data).then(res=>{
        commit('setStaticalList',res.data)
        commit('setTotalCount',res.data.totalCount)
        return res
      })
    },
    getTotalStatical({commit},data){
      return api.getTotalStatical(data).then(res=>{
        console.log('getTotalStatical-data',res);
        commit('setTotalStaticalList',res.data)
        return res
      })
    },
    exportExcel({commit},data){
      return api.exportExcel(data).then(res=>{
        console.log('exportExcel-res',res);
        return res
      })
    },
    getAllSymbol({commit},{buyCoin,page,size,symbol,state}){
      api.getAllSymbol({buyCoin,page,size,symbol,state}).then(res=>{
        // console.log('symboldatas',res);
        commit('setSymbolData',res.data.list)
      })
    },
    reqList({commit},data){

    }
  }
};

appStore.registerModule('report', store);
